import { HubConnectionBuilder } from "@microsoft/signalr";
import * as Constants from "./Constants";
var { IPACK_PATH } = Constants;

class SignalRUtil {
  constructor(baseUrl = IPACK_PATH + "/signalr") {
    this.$ = window.jQuery;
    this.baseUrl = baseUrl;
    this.connectionStatusRetry = null;

    this._bindClientCallbacks = this._bindClientCallbacks.bind(this);
    this._autoRetryConnect = this._autoRetryConnect.bind(this);
    this._callback = this._callback.bind(this);

    this.setBoxDeliveryCallback = this.setBoxDeliveryCallback.bind(this);
    this.start = this.start.bind(this);
    this.getState = this.getState.bind(this);
  }
  start(workstationID) {
    this.$.connection.hub.url = this.baseUrl;
    this.$.connection.hub.qs = "Workstation-Id=" + workstationID;
    this._autoStop();
    this._bindClientCallbacks(this.$.connection.messageHub);
    this._autoRetryConnect();
  }

  _callback(data, target) {
    if (this[target] && typeof this[target] === "function") {
      this[target](data);
    }
  }

  _multipleWindowRedirect() {
    window.location.href = window.location.href.split("?")[0] + "?dwerror=1";
  }

  _bindClientCallbacks(hubProxy) {
    hubProxy.client.requestBoxDelivery = (data) => this._callback(data, "boxDeliveryCallback");
    hubProxy.client.boxError = (data) => this._callback(data, "boxErrorCallback");
    hubProxy.client.showErrorMessage = (message) => this._callback(message, "showErrorCallback");
    hubProxy.client.reportBoxEject = (data) => this._callback(data, "boxEjectCallback");
    hubProxy.client.responseBoxReset = (data) => this._callback(data, "boxResetCallback");
    hubProxy.client.reportBoxAtTable = (data) => this._callback(data, "boxAtTableCallback");
    hubProxy.client.multipleWindow = () => this._multipleWindowRedirect();
  }
  _autoStop() {
    window.onbeforeunload = function (e) {
      this.$.connection.hub.stop();
    };
  }
  _autoRetryConnect() {
    this.$.connection.hub
      .start()
      .done(() => {
        //console.log("[signalr]connection success")
        this.isConnected = true;
        this.connectionStatusRetry = setInterval(() => {
          if (this.getState() === 4) {
            this._autoRetryConnect();
            clearInterval(this.connectionStatusRetry);
          }
        }, 2000);
      })
      .fail((e) => {
        //console.log("[signalr]connection failure",e)
        setTimeout(this._autoRetryConnect, 2000);
      });
  }

  downloadHubProxies(retry) {
    return new Promise((resolve, reject) => {
      var earlierScript = document.getElementById("hubs");
      if (earlierScript) earlierScript.remove();

      let script = document.createElement("script");
      script.src = this.baseUrl + "/hubs";
      script.id = "hubs";
      document.head.append(script);

      script.onerror = () => {
        if (retry) {
          setTimeout(() => resolve(this.downloadHubProxies(retry)), 5000);
        } else {
          reject();
        }
      };
      script.onload = () => {
        resolve();
      };
    });
  }

  setBoxDeliveryCallback(callback) {
    this.boxDeliveryCallback = callback;
  }
  setBoxErrorCallback(callback) {
    this.boxErrorCallback = callback;
  }
  setShowErrorCallback(callback) {
    this.showErrorCallback = callback;
  }
  setBoxEjectCallback(callback) {
    this.boxEjectCallback = callback;
  }
  setBoxResetCallback(callback) {
    this.boxResetCallback = callback;
  }
  setBoxAtTableCallback(callback) {
    this.boxAtTableCallback = callback;
  }
  isRunning() {
    return !!this.isConnected;
  }
  getState() {
    return this.$.connection.hub.state;
  }
}

export const SignalR = new SignalRUtil();

class ClientMetadata {
  constructor(receiverId, receiverGroup) {
    this.receiverId = receiverId;
    this.receiverGroup = receiverGroup;
  }
}

// GENERAL CHECKSTATION SIGNALR - VARBERG

class CheckStationHub {
  static BASE_URL = "http://localhost:54229";
  static TARGET_HUB = "CheckStationHub";
  _baseConnection;
  _hubProxy;

  connect() {
    this._prepareConnection();
    this._prepareHubProxy();
    this._startConnection();
  }

  _prepareConnection() {
    this._baseConnection = window.jQuery.hubConnection(CheckStationHub.BASE_URL);
    this._setConnectionWorkstation();
    this._initializeLifecycleHandlers();
  }

  _setConnectionWorkstation() {
    this._baseConnection.qs = { "Workstation-Id": this._getWorkstationId() };
  }

  _prepareHubProxy() {
    this._hubProxy = this._baseConnection.createHubProxy(CheckStationHub.TARGET_HUB);
    this._hubProxy.on("ReceiveMessage", (message) => {
      console.log("Message from server:", message);
    });
  }

  _initializeLifecycleHandlers() {
    //? Fires when the client is trying to reconnect
    this._baseConnection.reconnecting(() => {
      console.warn(`Reconnecting to ${CheckStationHub.TARGET_HUB}...`);
    });

    //? Fires when the connection successfully reconnects
    this._baseConnection.reconnected(() => {
      console.log(`Reconnected to ${CheckStationHub.TARGET_HUB}!`);
    });

    //? Fires when the connection is permanently disconnected and tries reconnecting after delay
    this._baseConnection.disconnected(() => {
      console.error(`Disconnected from ${CheckStationHub.TARGET_HUB}.`);

      setTimeout(() => {
        this._startConnection();
      }, 5000);
    });

    this._baseConnection.error((error) => {
      console.error("SignalR Error:", error);
    });
  }

  _startConnection() {
    this._baseConnection
      .start()
      .done(() => console.log("Connected successfully."))
      .fail((err) => console.error("Connection failed:", err.toString()));
  }

  _getWorkstationId() {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get("ws") || "default-ws-id";
  }
}

export const checkStationHub = new CheckStationHub();

// const connection = window.jQuery.hubConnection(this.BASE_URL);
// connection.qs = { "Workstation-Id": 123 };
// const checkStationHubProxy = connection.createHubProxy("CheckStationHub");

// checkStationHubProxy.on("ReceiveMessage", function (message) {
//   console.log("Message from server:", message);
// });

// connection.start().done(() => {
// var newMessage = new ClientMetadata(Math.random().toString(), "testGroup");
// checkStationHubProxy
//   .invoke("SendMessageToExternalHub", newMessage)
//   .then(() => console.log("sent to external hub"))
//   .catch(function (err) {
//     return console.error(err.toString());
//   });
// });

// // Fires when the connection starts reconnecting after a disconnection
// connection.reconnecting(function () {
//   console.warn("Reconnecting to CheckStationHub...");
// });

// // Fires when the connection successfully reconnects
// connection.reconnected(function () {
//   console.log("Reconnected to CheckStationHub!");
// });

// // Fires when the connection is permanently disconnected
// connection.disconnected(function () {
//   console.error("Disconnected from CheckStationHub.");

//   // Optionally, restart the connection after a delay
//   setTimeout(() => {
//     connection
//       .start()
//       .done(() => console.log("Reconnected successfully."))
//       .fail((err) => console.error("Reconnection failed:", err.toString()));
//   }, 5000); // Attempt reconnection after 5 seconds
// });

// // Fires when there is an error in the connection
// connection.error(function (error) {
//   console.error("SignalR Error:", error);
// });
